import getCdnUrl from '../../../helpers/get-cdn-url';

const ItauLogo = getCdnUrl('/logos/itau.avif');

export default ItauLogo;
